import axios from 'axios';
import {message} from "antd";
import {data, useNavigate} from "react-router-dom";

// 创建axios实例
const instance = axios.create({
    // baseURL: 'http://localhost:6549/api', // 本地开发环境
    // baseURL: 'http://175.27.227.159/api', // 实际服务器地址
    baseURL:'https://narenqiqige.com/api', // 实际服务器域名
    timeout: 30000,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

// 请求拦截器
instance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = token;
        } else if (!config.url.includes('/user/login')) {
            message.error('未登录或登录已过期，请重新登录');
        }
        return config;
    },
    error => {
        console.error('请求错误:', error);
        return Promise.reject(error);
    }
);


// 响应拦截器
instance.interceptors.response.use(
    response => {
        if (response.data.code === 200) {
            return response.data;
        } else if (response.data.code === 401 || response.data.code === 400) {
            message.error(response.data.message || '认证失败，请重新登录');
            setTimeout(() => {
                window.location.href = '/login';
            }, 1500);
            return Promise.reject(response.data);
        } else {
            // 对于其他业务错误，直接将响应数据返回给调用方处理
            return response.data;
        }
    },
    error => {
        console.error('响应错误:', error);
        if (error.response) {
            message.error(`请求失败: ${error.response.data.message || error.response.status}`);
        } else if (error.request) {
            message.error('网络错误，请检查您的网络连接');
        } else {
            message.error('请求配置错误');
        }
        return Promise.reject(error);
    }
);

// API服务
const apiService = {
    baseURL: instance.defaults.baseURL,
    instance: instance,

    hairDye: {
        getList: (params) => instance.get('/hair-dye', { params }),
        getById: (id) => instance.get(`/hair-dye/${id}`),
        create: (data) => instance.post('/hair-dye', data),
        update: (id, data) => instance.put(`/hair-dye/${id}`, data),
        delete: (id) => instance.delete(`/hair-dye/${id}`),
        getStockList: (dyeId, params) => instance.get(`/hair-dye/${dyeId}/inventory`, { params }),
        getSpecs: (dyeId, includeInvalid = false) => instance.get(`/hair-dye/${dyeId}/specs`, { params: { includeInvalid } }),
        createSpec: (dyeId, data) => instance.post(`/hair-dye/${dyeId}/specs`, data),
        updateSpec: (specId, data) => instance.put(`/hair-dye/specs/${specId}`, data),
        generateStock: (dyeId, data) => instance.post(`/hair-dye/${dyeId}/batch-create`, data),
        exportQrCodes: (data) => {
            const params = {};
            const hasStart = data.startId !== undefined && data.startId !== null && data.startId !== '';
            const hasEnd = data.endId !== undefined && data.endId !== null && data.endId !== '';

            if (hasStart || hasEnd) {
                if (!hasStart || !hasEnd) {
                    message.error('导出时起始ID和结束ID不能缺失任何一个');
                    return Promise.reject(new Error('startId and endId cannot be missing'));
                }
                params.startId = data.startId;
                params.endId = data.endId;
            } else {
                params.ids = data.ids;
            }

            return instance.post('/hair-dye/generate-qrcode-zip', params, {
                responseType: 'blob' 
            });
        }
    },

    store: {
        getList: (params) => instance.get('/stores/list', { params }), // 支持分页和搜索参数
    },

    colorRecord : {
        getRecordUserList : () => instance.get('/record/manage-user-list'),
        getColorRecordList: (pageNum, pageSize,userId = null) => instance.get(`/record/manage-list?pageNum=${pageNum}&pageSize=${pageSize}&${userId ? 'userId=' + userId : ''}`),
        getColorRecordDetail: (id) => instance.get(`/record/manage-detail/${id}`),
        updateFeatured : (id, featured) => instance.put(`/record/manage-featured/${id}`, {}, {
            params: { featured }
        }),
        updateCustomDescription : (id, description) => instance.put(`/record/manage-custom-description/${id}`, {}, {
            params: { description }
        }),
        deleteColorRecord:(id)  => instance.delete(`/record/${id}`)
    },

    equipmentVideos: {
        create: (formData) => {
            return instance.post('/equipment-video', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        update: (id, formData) => instance.put(`/equipment-video/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        delete: (id) => instance.delete(`/equipment-video/${id}`),
        get: (id) => instance.get(`/equipment-video/${id}`),
        getEquipmentVideoList: (pageNum, pageSize) => instance.get(`/equipment-video/list?pageNum=${pageNum}&pageSize=${pageSize}`),
    },

    firmwareUpgrade: {
        uploadFirmwareUpgrade: (file) => {
            const formData = new FormData();
            formData.append('file', file);
            return instance.post('/firmware/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        getFirmwareUpgrade: (pageNum, pageSize, status) => instance.get(`/firmware/list?pageNum=${pageNum}&pageSize=${pageSize}&status=${status}`),
        updateFirmwareUpgrade: (id, data) => instance.put(`/firmware/${id}`, data),
        deleteFirmwareUpgrade: (id) => instance.delete(`/firmware/${id}`),
        batchDeleteFirmwareUpgrade: (ids) => instance.delete(`/firmware/batch?ids=${ids}`),
        getFirmwareUpgradeRecordList: (pageNum, pageSize, status) => instance.get(`/firmware/record/list?pageNum=${pageNum}&pageSize=${pageSize}`),
    },

    // 配方相关API
    formula: {
        getAll: () => instance.get('/formula/all'),
        getById: (id) => instance.get(`/formula/${id}`),
        create: (data) => instance.post('/formula/create', data),
        update: (id, data) => instance.put(`/formula/${id}`, data),
        delete: (id) => instance.delete(`/formula/${id}`),
        getDetail: (id) => instance.get(`/formula/${id}`),
        getByPage: (pageNum, pageSize, colorType, keyword) =>
            instance.get(`/formula/list?pageNum=${pageNum}&pageSize=${pageSize}&colorType=${colorType}&keyword=${keyword}`),
        getCategory: () => instance.get('/formula/detail-color'),
        getColorType: () => instance.get('/formula/color-type'),
    },

    // 用户相关API
    user: {
        login: (data) => instance.post('/user/login', data),
        register: (data) => instance.post('/user/register', data),
        getUsers: () => instance.get('/user/admin/all-user'),
        addUser: (data) => instance.post('/user/admin/register', data),
        updateUser: (data) => instance.put('/user/admin/update-user', data),
        disableUser: (id) => instance.put(`/user/admin/disable-user/${id}`),
        enableUser: (id) => instance.put(`/user/admin/enable-user/${id}`),
        deleteUser: (id) => instance.delete(`/user/admin/delete-user/${id}`),

        // 新增的用户中心相关接口
        getInfo: () => instance.get('/user/info'),
        updateProfile: (data) => instance.put('/user/info', data), // 更新基本信息
        changePassword: (data) => instance.put('/user/password', data), // 修改密码
        uploadAvatar: (file) => { // 上传头像
            const formData = new FormData();
            formData.append('file', file);
            return instance.post('/user/avatar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        }
    },

    system: {
        getSystemInfo: () => instance.get('/system/info'),
    },
};

export default apiService;
